import Api from "./Api/Api";
import { isInr } from "./currency";

const Helper = {
    isMobile: () => {
        return window.innerWidth < 1280;
    },
    dateFormat: (date) => {
        if(!date) {
            return '';
        }
        const d = new Date(date);
        const month = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        return `${d.getDate()} ${month[d.getMonth()]} ${d.getFullYear()}`
    },
    dateCrossed: (date) => {
        if (!date) {
            return false;
        }
        const currentDate = new Date();
        const expiryDate = new Date(date);
        return currentDate > expiryDate;
    },
    // Remembers the last plan's currency when it isn't rupees (dollars, or a
    // store's own currency such as euros), for screens with no plan to ask.
    checkAndHandleUSDCurrency: async (currency_type) => {
        if (currency_type && !isInr(currency_type)) {
            const prevCurrencyType = localStorage.getItem('current_currency_type');
            localStorage.setItem('current_currency_type', currency_type);
        }
    }
}

export default Helper;